<script>
export default {
  name: "WarningText",
  props: {
    text: [String],
  },
};
</script>

<template>
  <div class="flex items-center gap-2 px-4 py-3 rounded-xl bg-orange-400/10">
    <svg
      class="w-4 h-4 text-yellow-600 flex-shrink-0"
      fill="none"
      stroke="currentColor"
      stroke-width="1.5"
      viewBox="0 0 24 24"
    >
      <path
        stroke-linecap="round"
        stroke-linejoin="round"
        d="M12 9v2m0 4h.01M10.29 3.86l-7.2 12.48A2 2 0 004.8 19h14.4a2 2 0 001.71-2.66l-7.2-12.48a2 2 0 00-3.42 0z"
      />
    </svg>
    <p class="text-xs text-gray-800 leading-4">
      {{ text }}
    </p>
  </div>
</template>

<style scoped lang="scss"></style>
